const NO_DOUBLE_NEWLINE = ['list-item', 'o-list-item']

const extractNewlinesAroundText = (input) => {
  const [newlinesStart] = (input.match(/^\n*/) || [''])
  const [newlinesEnd] = (input.match(/\n*$/) || [''])

  return {
    newlinesStart,
    newlinesEnd,
    text: input.substring(newlinesStart.length, input.length - newlinesEnd.length)
  }
}

const moveSpansForNewlines = (input, spans) => (
  spans.map(span => {
    const { newlinesStart, newlinesEnd } = extractNewlinesAroundText(input.substring(span.start, span.end))

    return {
      ...span,
      start: span.start + newlinesStart.length,
      end: span.end - newlinesEnd.length
    }
  })
)

const mapMarkdown = (type, data) => {
  switch (type) {
    case 'em': return ['*', '*']
    case 'strong': return ['**', '**']
    case 'hyperlink': return ['[', `](${data.url})`]
    default: return ['', '']
  }
}

const handleSpans = (text, spans) => {
  const prefixesAndSuffixes = {}

  spans.forEach(span => {
    const spanMarkdown = mapMarkdown(span.type, span.data)
    prefixesAndSuffixes[span.start] = (prefixesAndSuffixes[span.start] || '') + spanMarkdown[0]
    prefixesAndSuffixes[span.end] = spanMarkdown[1] + (prefixesAndSuffixes[span.end] || '')
  })

  const sortedSuffixes = Object.entries(prefixesAndSuffixes).sort((a, b) => b[0] - a[0])
  for (const [end, prefixedString] of sortedSuffixes) {
    text = text.substring(0, end) + prefixedString + text.substr(end)
  }

  return text
}

const handlePart = (singleNewline) => (part, index, arr) => {
  const lastPart = index > 0 && arr[index - 1]
  let str = ''

  if (part.type === 'image') {
    return `![](${part.url} "${part.alt ? part.alt : ''}")`
  }

  if (part.type === 'embed' && part.oembed.type === 'video') {
    const { embed_url: url, html } = part.oembed
    const [, embeddedUrl] = html.match(/src="(.*?)"/) || []
    return `[video-embedded url="${embeddedUrl || url}"]`
  }

  const { text, newlinesStart, newlinesEnd } = extractNewlinesAroundText(part.text)

  switch (part.type) {
    case 'heading1':
      str += newlinesStart + '# ' + handleSpans(text, part.spans) + newlinesEnd
      break

    case 'heading2':
      str += newlinesStart + '## ' + handleSpans(text, part.spans) + newlinesEnd
      break

    case 'heading3':
      str += newlinesStart + '### ' + handleSpans(text, part.spans) + newlinesEnd
      break

    case 'heading4':
      str += newlinesStart + '#### ' + handleSpans(text, part.spans) + newlinesEnd
      break

    case 'heading5':
      str += newlinesStart + '##### ' + handleSpans(text, part.spans) + newlinesEnd
      break

    case 'heading6':
      str += newlinesStart + '###### ' + handleSpans(text, part.spans) + newlinesEnd
      break

    case 'list-item':
      str += '* ' + handleSpans(part.text, part.spans)
      break

    case 'o-list-item':
      str += '1. ' + handleSpans(part.text, part.spans)
      break

    case 'paragraph':
      str += handleSpans(part.text, moveSpansForNewlines(part.text, part.spans))
      break
  }

  if (!singleNewline && str && lastPart && !(part.type === lastPart.type && NO_DOUBLE_NEWLINE.includes(part.type))) {
    return '\n' + str
  }

  return str
}

exports.richTextToMarkdown = (input, singleNewline) => (
  input ? input.map(handlePart(singleNewline)).join('\n') : input
)

exports.richTextToMarkdownArray = (input) => (
  input ? input.map(handlePart(true)) : input
)



// WEBPACK FOOTER //
// ./helpers/cms.js